import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { ListDeliveredMedicationsResponse } from 'vidis-common/delivered-medication';
import { CountResult } from 'vidis-common/common/models/count-result.model';

export const DeliveredMedicationsApiActions = createActionGroup({
  source: 'DELIVERED MEDICATIONS API',
  events: {
    'fetch delivered medications': emptyProps(),
    'fetch count': emptyProps(),
  }
});

export const DeliveredMedicationsStoreActions = createActionGroup({
  source: 'DELIVERED MEDICATIONS STORE',
  events: {
    'set delivered medications': props<{ listDeliveredMedications: ListDeliveredMedicationsResponse }>(),
    'set delivered medications count': props<{ countDeliveredMedication: CountResult }>(),
    'stop delivered medications loading': emptyProps(),
    'clear delivered medications': emptyProps(),
    'toggle delivered medications disclaimer': emptyProps(),
  }
});
